/* eslint-disable */
import React from 'react';
import { useParams, Link, Redirect } from 'react-router-dom';
import SEO from '../SEO';
import posts from './posts';

const CATEGORY_LABELS = {
  'storage-tips': 'Storage Tips',
  'moving-advice': 'Moving Advice',
  'company-updates': 'Company Updates',
  'local-content': 'SF & Bay Area',
};

const SITE_URL = 'https://bins-storage.com';

const pageContainer = {
  minHeight: '100vh',
  backgroundColor: '#261136',
  padding: 24,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
};

const shellCard = {
  width: '100%',
  maxWidth: 900,
  background: 'radial-gradient(circle at top, #3A1F52 0, #170824 45%, #12061f 100%)',
  borderRadius: 16,
  padding: '32px 32px 56px',
  boxSizing: 'border-box',
  boxShadow: '0 18px 45px rgba(0,0,0,0.45)',
  color: '#F5F5FA',
};

const breadcrumb = {
  fontSize: 13,
  color: '#AAB5E0',
  marginBottom: 24,
};

const breadcrumbLink = {
  color: '#AAB5E0',
  textDecoration: 'none',
};

const categoryBadge = {
  display: 'inline-block',
  background: 'rgba(170,181,224,0.15)',
  color: '#AAB5E0',
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  padding: '3px 10px',
  borderRadius: 20,
  marginBottom: 16,
};

const postTitle = {
  fontSize: 34,
  fontWeight: 700,
  color: '#F5F5FA',
  lineHeight: 1.25,
  marginBottom: 12,
};

const postMeta = {
  fontSize: 13,
  color: '#AAB5E0',
  marginBottom: 36,
  borderBottom: '1px solid rgba(255,255,255,0.08)',
  paddingBottom: 24,
};

const sectionHeading = {
  fontSize: 20,
  fontWeight: 600,
  color: '#AAB5E0',
  marginTop: 36,
  marginBottom: 12,
};

const sectionBody = {
  fontSize: 15,
  color: 'rgba(245,245,250,0.88)',
  lineHeight: 1.75,
  whiteSpace: 'pre-wrap',
};

const backLink = {
  display: 'inline-block',
  marginTop: 48,
  color: '#AAB5E0',
  textDecoration: 'none',
  fontSize: 14,
  borderTop: '1px solid rgba(255,255,255,0.08)',
  paddingTop: 24,
  width: '100%',
};

const BlogPost = () => {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) return <Redirect to="/blog" />;

  const formatDate = (dateStr) => {
    const d = new Date(dateStr + 'T12:00:00');
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: post.title,
    description: post.description,
    datePublished: post.date,
    dateModified: post.date,
    author: {
      '@type': 'Organization',
      name: 'Bins Storage',
      url: SITE_URL,
    },
    publisher: {
      '@type': 'Organization',
      name: 'Bins Storage',
      logo: {
        '@type': 'ImageObject',
        url: `${SITE_URL}/android-chrome-512x512.png`,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/blog/${post.slug}`,
    },
  };

  return (
    <>
      <SEO
        title={`${post.title} | Bins Storage Blog`}
        description={post.description}
        path={`/blog/${post.slug}`}
        type="article"
        schema={articleSchema}
      />
      <div style={pageContainer}>
        <div style={shellCard}>
          <div style={breadcrumb}>
            <Link to="/" style={breadcrumbLink}>Home</Link>
            {' / '}
            <Link to="/blog" style={breadcrumbLink}>Blog</Link>
            {' / '}
            {CATEGORY_LABELS[post.category] || post.category}
          </div>

          <div style={categoryBadge}>
            {CATEGORY_LABELS[post.category] || post.category}
          </div>

          <h1 style={postTitle}>{post.title}</h1>
          <div style={postMeta}>{formatDate(post.date)}</div>

          {post.sections.map((section, i) => (
            <div key={i}>
              {section.heading && (
                <h2 style={sectionHeading}>{section.heading}</h2>
              )}
              <p style={sectionBody}>{section.body}</p>
            </div>
          ))}

          <Link to="/blog" style={backLink}>← Back to all posts</Link>
        </div>
      </div>
    </>
  );
};

export default BlogPost;
